import { List, Typography } from "@mui/material";
import { TodoListItem } from "Components/Shared/TodoList/TodoListItem";

type TodoItem = {
  text: string;
  isCompleted: boolean;
};

type Props = {
  title: string;
  todoItems: Array<TodoItem>;
};

export const TodoList = ({ todoItems, title }: Props) => (
  <List>
    <Typography fontWeight={400}>{title}</Typography>
    {todoItems.map(({ text, isCompleted }) => (
      <TodoListItem key={text} text={text} isCompleted={isCompleted} />
    ))}
  </List>
);
